import { Mutations } from "vuex";
import { DirectUploadsState, DirectUploadsMutations } from "./types";

export const mutations: Mutations<DirectUploadsState, DirectUploadsMutations> =
  {
    updateDirectUpload(state, payload) {
      state ? Object.assign(state, payload) : payload;
    },
  };
